import { SIGNUP_URL } from "../constants";
import heroScreenshot from "../assets/hero-screenshot.webp";

export function Hero() {
  return (
    <section className="container mx-auto grid gap-10 px-4 py-16 lg:grid-cols-2 lg:items-center lg:py-24">
      <div className="space-y-6">
        <h1 className="text-4xl font-semibold tracking-tight sm:text-5xl">
          News intelligence built for active traders.
        </h1>
        <p className="max-w-xl text-lg text-muted-foreground">
          Tapelens detects market-moving events the moment they break, scores them
          for direction and impact, and answers your why-questions with cited
          sources — so you can act on signal, not noise.
        </p>
        <div className="flex flex-wrap gap-3">
          <a
            href={SIGNUP_URL}
            className="rounded-md bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground hover:opacity-90"
          >
            Start your 14-day free trial
          </a>
          <a
            href="#pricing"
            className="rounded-md border border-border px-5 py-2.5 text-sm font-medium text-foreground hover:bg-accent"
          >
            See pricing
          </a>
        </div>
      </div>
      <div className="lg:justify-self-end">
        <img
          src={heroScreenshot}
          alt="Tapelens dashboard showing real-time news events and sentiment scoring across two instruments."
          loading="eager"
          width={1200}
          height={800}
          className="rounded-lg border border-border shadow-lg"
        />
      </div>
    </section>
  );
}
